var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"padding-bottom":"0"}},[_c('iframe',{attrs:{"frameborder":"0","src":"https://m.black-unique.com/activate","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }